import './_swym-modal.scss';

export default () => {};
